export const homeData = {
  hero: {
    title: "17c一起草官网入口",
    subtitle: "官方正版直达通道 · 安全稳定 · 永久有效",
    description: "提供17c一起草官网入口最新地址、安全登录通道及完整功能体验。快速找到17c一起草官网入口，享受稳定流畅的官方服务，收藏本页永久有效，告别失效链接烦恼。",
    ctaText: "立即进入官网",
    ctaLink: "#entrance",
    secondaryText: "了解更多",
    secondaryLink: "#features",
  },
  entrance: {
    title: "官方入口直达",
    subtitle: "选择您需要的入口，一键直达官方服务",
    cards: [
      {
        id: "main",
        title: "主入口",
        description: "17c一起草官方网站主入口，提供完整功能体验，推荐首选访问。",
        icon: "ri-home-8-line",
        link: "#",
        badge: "推荐",
        badgeColor: "bg-primary-500",
      },
      {
        id: "mirror",
        title: "镜像入口",
        description: "备用镜像通道，网络高峰期提供同样稳定流畅的访问体验。",
        icon: "ri-cast-line",
        link: "#",
        badge: "备用",
        badgeColor: "bg-accent-500",
      },
      {
        id: "mobile",
        title: "移动端入口",
        description: "专为移动设备优化的轻量入口，随时随地畅享官方服务。",
        icon: "ri-smartphone-line",
        link: "#",
        badge: "轻量",
        badgeColor: "bg-secondary-500",
      },
    ],
  },
  features: {
    title: "为什么选择我们",
    subtitle: "17c一起草官网入口为您提供全方位优质服务体验",
    items: [
      {
        id: 1,
        icon: "ri-shield-check-line",
        title: "官方正版认证",
        description: "所有入口均经过官方正版认证，确保您访问的是真正的17c一起草官方网站，杜绝钓鱼和仿冒风险，保障您的账号信息安全。",
      },
      {
        id: 2,
        icon: "ri-speed-up-line",
        title: "极速稳定访问",
        description: "采用先进的网络加速技术，智能选择最优线路，无论何时何地都能享受17c一起草官网入口的高速稳定服务。",
      },
      {
        id: 3,
        icon: "ri-refresh-line",
        title: "地址实时更新",
        description: "17c一起草官网入口地址实时同步更新，确保您始终使用最新、最有效的官方通道，不必担心链接失效问题。",
      },
      {
        id: 4,
        icon: "ri-lock-2-line",
        title: "安全加密传输",
        description: "全程采用SSL/TLS加密技术保护您的数据传输安全，登录17c一起草官方网站时个人信息得到全方位防护。",
      },
      {
        id: 5,
        icon: "ri-customer-service-2-line",
        title: "7×24小时服务",
        description: "专业客服团队全天候在线，随时解答您在使用17c一起草官网入口过程中遇到的任何疑问。",
      },
      {
        id: 6,
        icon: "ri-star-line",
        title: "收藏永久有效",
        description: "收藏本页面即可永久获得17c一起草最新官网入口地址，再也不用担心找不到正确的官方网站。",
      },
    ],
  },
  trust: {
    title: "数百万用户信赖的选择",
    subtitle: "17c一起草官网入口已成为广大用户首选的官方导航平台",
    stats: [
      { value: "500万+", label: "累计访问用户" },
      { value: "99.9%", label: "服务可用率" },
      { value: "365天", label: "全年无休服务" },
      { value: "50万+", label: "日均活跃用户" },
    ],
  },
  faq: {
    title: "常见问题",
    subtitle: "关于17c一起草官网入口的常见疑问解答",
    items: [
      {
        question: "17c一起草官网入口是什么？",
        answer: "17c一起草官网入口是17c一起草官方认证的正版直达通道，为用户提供最新、最安全、最稳定的官方访问入口。通过本页面，您可以快速找到17c一起草官方网站，享受完整的官方功能体验。",
      },
      {
        question: "如何确认访问的是17c一起草官方网站？",
        answer: "通过本页面提供的17c一起草官网入口进行访问，所有入口均经过官方认证。您可以通过检查网址、安全证书标识（SSL锁形图标）以及页面内容来确认是否为17c一起草官方网站。",
      },
      {
        question: "17c一起草官网入口地址会变更吗？",
        answer: "17c一起草官网入口地址会根据需要进行优化和调整，但我们承诺本页面会实时同步更新最新地址。您只需收藏本页面，即可永久获得最新的17c一起草官网入口地址。",
      },
      {
        question: "如果遇到访问问题怎么办？",
        answer: "如果您通过17c一起草官网入口访问时遇到问题，可以尝试以下方法：1）清除浏览器缓存和Cookie后重试；2）切换至备用镜像入口；3）更换网络环境；4）联系我们的在线客服获取帮助。",
      },
      {
        question: "收藏此页面真的永久有效吗？",
        answer: "是的，我们承诺本页面地址永久有效。即使17c一起草官方网站地址发生变更，我们也会第一时间更新本页面的入口链接，确保您总能通过收藏的页面找到正确的官方入口。",
      },
      {
        question: "17c一起草官网入口支持哪些设备？",
        answer: "17c一起草官网入口全面支持PC端、平板电脑和移动手机等各类设备。我们提供自适应的页面设计和专门的移动端入口，确保您在任何设备上都能获得流畅的访问体验。",
      },
    ],
  },
};